import { render, staticRenderFns } from "./TalkjsTrigButton.vue?vue&type=template&id=60b0844c&scoped=true&"
import script from "./TalkjsTrigButton.vue?vue&type=script&lang=js&"
export * from "./TalkjsTrigButton.vue?vue&type=script&lang=js&"
import style0 from "./TalkjsTrigButton.vue?vue&type=style&index=0&id=60b0844c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b0844c",
  null
  
)

export default component.exports